import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
  creditOrPrecreditAmt?: number;
  checkResultReqMap: {
    [key: string]: {
      success: boolean;
      result: any;
    };
  };
  commonResultText?: string; // commonResult页面中展示的提示文案
}

const initialState: CommonState = {
  creditOrPrecreditAmt: 0,
  checkResultReqMap: {},
  commonResultText: '',
};

const webPubSlice = createSlice({
  name: 'webPubStore',
  initialState,
  reducers: {
    setCreditOrPrecreditAmt: (state, action: PayloadAction<number>) => {
      state.creditOrPrecreditAmt = action.payload;
    },
    addCheckResultReqMap: (state, action: PayloadAction<[string, boolean, any]>) => {
      state.checkResultReqMap[action.payload[0]] = {
        success: action.payload[1],
        result: action.payload[2],
      };
    },
    setCommonResultText: (state, action: PayloadAction<string>) => {
      state.commonResultText = action.payload;
    },
  },
});

const { setCreditOrPrecreditAmt, addCheckResultReqMap, setCommonResultText } = webPubSlice.actions;

export { setCreditOrPrecreditAmt, addCheckResultReqMap, setCommonResultText };

export default webPubSlice.reducer;
